import React, { FunctionComponent, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Color } from '../../config/Color';
import { AppSelector, useAppStore } from '../../store/Store';
import { Heading3 } from '../styles/Typography';

export const ErrorToolbox: FunctionComponent = () => {
  const { userError, paymentError, loading } = useAppStore((state) => ({
    userError: AppSelector.userState(state).error,
    paymentError: state.purchase.payment.error,
    loading: state.purchase.payment.loading || state.user.loading,
  }));
  const [expanded, setExpanded] = useState(false);

  useEffect(
    function openDrawerWhenError() {
      if (userError !== undefined || paymentError !== undefined) {
        setExpanded(true);
      }
    },
    [userError, paymentError]
  );

  return (
    <Toolbox>
      <ToolboxDrawer expanded={expanded}>
        <ToolboxControls onClick={() => setExpanded(!expanded)}>II</ToolboxControls>
        <ToolboxContent>
          {userError !== undefined && (
            <>
              <Header>Authentication error:</Header>
              <ErrorBox>{userError.message}</ErrorBox>
            </>
          )}
          {paymentError !== undefined && (
            <>
              <Header>Payment error:</Header>
              <ErrorBox>{paymentError.message}</ErrorBox>
            </>
          )}
          {loading && (
            <>
              <Header>Loading...</Header>
            </>
          )}
          {userError === undefined && paymentError === undefined && (
            <>
              <Header>
                Great job no errors{' '}
                <span role="img" aria-label="thumbs up emoji">
                  👍
                </span>
              </Header>
            </>
          )}
        </ToolboxContent>
      </ToolboxDrawer>
    </Toolbox>
  );
};

const ErrorBox = styled.div`
  border: 1px solid;
  margin: ${({ theme }) => `${theme.spacing._10px} 0`};
  border: solid ${Color.state.error};
  background-color: ${`${Color.state.error}10`};
  padding: ${({ theme }) =>
    `${theme.spacing._16px} ${theme.spacing._10px} ${theme.spacing._16px} ${theme.spacing._10px}`};
  border-radius: ${({ theme }) => theme.spacing._16px};
`;

const Toolbox = styled.div`
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  height: 100vh;
  z-index: 999;
`;

const ToolboxDrawer = styled.div<{ expanded: boolean }>`
  z-index: 1;
  display: flex;
  background-color: white;
  border: solid ${Color.state.error};
  border-width: 2px 2px 2px 0;
  ${({ theme }) => theme.shadow.drop.gray};
  overflow: hidden;
  width: ${({ expanded }) => (expanded ? 300 : 26)}px;
  height: 300px;
  border-radius: 0 16px 16px 0;
  transition: all 350ms ease-in-out;
`;

const ToolboxControls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.spacing._26px};
  min-width: ${({ theme }) => theme.spacing._26px};
  margin: 0;
  cursor: pointer;
  color: ${Color.state.error};
`;

const ToolboxContent = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing._16px} ${theme.spacing._16px} ${theme.spacing._16px} 0`};
  width: 274px;
  max-height: 300px;
  overflow-y: scroll;
`;

const Header = styled(Heading3)`
  width: 274px;
`;
